import * as React from "react";
const SvgFiRrChatArrowGrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-chat-arrow-grow_svg__a)">
      <path d="M22.5 3.976h-3.086a1 1 0 0 0-.707 1.707l1.086 1.086-3.586 3.585a1.024 1.024 0 0 1-1.415 0l-.17-.171a3.07 3.07 0 0 0-4.243 0l-5.1 5.1A1.003 1.003 0 1 0 6.7 16.7l5.1-5.1a1.023 1.023 0 0 1 1.415 0l.17.17a3.073 3.073 0 0 0 4.243 0l3.586-3.585L22.3 9.27a1 1 0 0 0 1.7-.71V5.477a1.5 1.5 0 0 0-1.5-1.5" />
      <path d="M23 21.976H5a3 3 0 0 1-3-3V1a1 1 0 0 0-2 0v17.976a5.006 5.006 0 0 0 5 5h18a1 1 0 0 0 0-2" />
    </g>
    <defs>
      <clipPath id="fi-rr-chat-arrow-grow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChatArrowGrow;
